import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUser} from '@fortawesome/free-solid-svg-icons'

export default class PostBinnacleComponent extends React.Component{

    render(){

        return(
            <div className="cn-binnacle-card">
                <div className="cn-binnacle-card-title">
                    <a onClick={()=>this.props.onHandleAppear(this.props.position)}><span className="txt-binnacle-card-title">{this.props.data.isChange == 0 ? "Sin cambio" : this.props.data.title}</span></a>
                </div>

                <div className="cn-binnacle-card-observations">
                    <p className="txt-binnable-card-observations">{this.props.data.observations}</p>
                </div>

                <div className="cn-binnacle-card-footer">
                    <div className="cn-binnacle-card-editedby">
                    <FontAwesomeIcon icon={faUser} size="1x" color={"#003A66"}/>
                        <span className="txt-binnacle-card-editedby">
                            {this.props.data.edit_by_name}
                        </span>
                    </div>
                    <div className="cn-binnacle-card-dateAudency">
                        <span className="txt-binnacle-card-dateAudency">
                            {this.props.data.createdAt}
                        </span>
                    </div>  
                </div>
                
                
            </div>
        )
    }



}

